import Colors from "../Colors";

export const EnumExpressions: { [key: number]: string } = Object.freeze({
  1: "LOST",
  2: "NOT CLEAR",
  3: "GREAT",
  4: "TOO HARD",
  5: "TOO SIMPLE",
});

export const EnumExpressionsNum: { [key: string]: number } = Object.freeze({
  LOST: 1,
  NOT_CLEAR: 2,
  GREAT: 3,
  TOO_HARD: 4,
  TOO_SIMPLE: 5,
});

export enum EnumExpressionsText {
  LOST = "LOST",
  NOT_CLEAR = "NOT_CLEAR",
  GREAT = "GREAT",
  TOO_HARD = "TOO_HARD",
  TOO_SIMPLE = "TOO_SIMPLE",
}

export const EnumExpressionColors: any = Object.freeze({
  1: Colors.RED_LIGHT,
  2: Colors.YELLOW_REACT,
  3: Colors.GREEN_SOLID,
  4: Colors.DARK_BLUE_HEADER,
  5: Colors.PINK_REACT,
});

export const mapExpressionPercentToColor = (expressionTag: any) => {
  switch (expressionTag) {
    case EnumExpressionsText.LOST:
      return "#f72f0a";
    case EnumExpressionsText.NOT_CLEAR:
      return "#ffd000";
    case EnumExpressionsText.GREAT:
      return "#22a700";
    case EnumExpressionsText.TOO_SIMPLE:
      return "#A300BF";
    case EnumExpressionsText.TOO_HARD:
      return "#108dff";
    default:
      console.error("error expression color");
      return;
  }
};

export const EnumExpressionAllByTag = {
  [EnumExpressionsText.LOST]: {
    tagNum: EnumExpressionsNum.LOST,
    tagLabel: "I'm lost",
  },
  [EnumExpressionsText.NOT_CLEAR]: {
    tagNum: EnumExpressionsNum.NOT_CLEAR,
    tagLabel: "Not Clear",
  },
  [EnumExpressionsText.GREAT]: {
    tagNum: EnumExpressionsNum.GREAT,
    tagLabel: "Great!",
  },
  [EnumExpressionsText.TOO_HARD]: {
    tagNum: EnumExpressionsNum.TOO_HARD,
    tagLabel: "Too Hard",
  },
  [EnumExpressionsText.TOO_SIMPLE]: {
    tagNum: EnumExpressionsNum.TOO_SIMPLE,
    tagLabel: "Too Simple",
  },
};
